(function () {
	angular
		.module('trackeye')
		.config(TrackeyeRouterConfig)
		.run(TrackeyeRouterAccess);

	TrackeyeRouterConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider', 'config'];
	TrackeyeRouterAccess.$inject = ['$rootScope', '$location', 'AuthService'];

	/**
	 * Define the app routes
	 */
	function TrackeyeRouterConfig($stateProvider, $urlRouterProvider, $locationProvider, config) {
		$urlRouterProvider.otherwise('/');

		$stateProvider
			.state('main', {
				url: '/',
				templateUrl: function() {
					if (config.defaults.settings.authPage)
						return "partials/auth/auth.html";

					return "partials/main/index.html";
				},
				requireToken: false
			})
			.state('sso', {
				url: '/sso?code&state&error&user&remember',
				templateUrl: 'partials/auth/sso.html',
				controller: 'AuthSsoController as AuthSsoCtrl'
			})
			.state('main.locale', {
				url: 'locale/:locale_code'
			})
			.state('main.impersonate', {
				url: 'impersonate/:impersonate_token'
			})
			.state('main.remote_auth', {
				url: 'remote/auth?tokenBase64'
			})
			.state('main.recover', {
				url: 'recover/:token',
				views: {
					"modalContainer@main": {
						templateUrl: "partials/modal/recover.html",
						controller: "ModalController as ModalCtrl"
					}
				}
			})
			.state('main.modal', {
				url: ':modal',
				params: {
					username: null
				},
				views: {
					"modalContainer@main": {
						templateUrl: function ($stateParams) {
							return "partials/modal/" + $stateParams.modal + ".html";
						},
						controller: "ModalController as ModalCtrl"
					}
				}
			})
			.state('dashboard', {
				url: "/dashboard",
				abstract: true,
				templateUrl: 'partials/dashboard/dashboard.html',
				requireToken: true,
				controller: 'DashboardController as DashboardCtrl',
				data: {
					requireToken: true
				}
			})
			.state('dashboard.main', {
				url: "",
				views: {
					"fleetContainer@dashboard": {
						templateUrl: 'partials/fleet/fleet.html',
						controller: 'FleetController as FleetCtrl'
					},
					"sidebarContainer@dashboard": {
						templateUrl: 'partials/sidebar/sidebar.html',
						controller: 'SidebarController as vm'
					},
					"sidebarContent@dashboard.main": {
						templateUrl: function ($stateParams) {
							return "partials/sidebar/positions.html";
						}
					}
				}
			})
			.state('dashboard.main.pages', {
				url: '/:page',
				views: {
					"sidebarContent@dashboard.main": {
						templateUrl: function ($stateParams) {
							return "partials/sidebar/" + $stateParams.page + ".html";
						}
					}
				}
			})
			.state('renew-subscription', {
				url: "/{nodeid:[0-9]{10}}",
				parent: 'dashboard.main.pages',
				views: {
					"modalContainer@dashboard": {
						templateUrl: function () {
							return "partials/modal/renew-subscription.html";
						},
						controller: "ModalController as ModalCtrl"
					}
				}
			})
			.state('dashboard.main.pages.modal', {
				url: '/:modal',
				params: {
					eventData: undefined
				},
				views: {
					"modalContainer@dashboard": {
						templateUrl: function ($stateParams) {
							return "partials/modal/" + $stateParams.modal + ".html";
						},
						controller: "ModalController as ModalCtrl"
					}
				}
			});

			$locationProvider.html5Mode(true);
	}

	/**
	 * Define rules to restricted routes
	 */
	function TrackeyeRouterAccess($rootScope, $location, AuthService) {
		$rootScope.$on("$stateChangeStart",
			function (e, toState, toParams, fromState, fromParams) {
				if (!AuthService.hasToken()) {
					if (stateRequireLogin(toState.data)) {
						$location.path("/");
					}
				}
			}
		);
	}

	/**
	 * Check if the requested state, requires authentication token
	 * @param  {Object} data
	 * @returns {boolean}
	 */
	function stateRequireLogin(data) {
		if (data === undefined)
			return false;

		if (data.requireToken === undefined) {
			return false;
		} else {
			return data.requireToken;
		}
	}
})();
